import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-2 sm:p-3", className)}
      classNames={{
        months: "flex flex-col gap-4 sm:flex-row sm:gap-6 sm:items-start",
        month: "space-y-3 rounded-xl border border-[#EBB3A9]/70 bg-white px-2 py-3 shadow-sm sm:px-3",
        caption: "flex justify-center pt-1 relative items-center mb-1",
        caption_label: "text-base font-semibold text-[#2D2D2D] tracking-tight",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-8 w-8 border-[#2D2D2D]/25 bg-white p-0 text-[#2D2D2D] opacity-90 hover:opacity-100 hover:bg-[#EEEBD0]"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse",
        head: "border-b border-[#EBB3A9]/50",
        head_row: "table-row",
        head_cell:
          "h-9 w-10 p-0 text-center align-middle text-[11px] font-semibold uppercase tracking-wide text-[#2D2D2D]/75",
        row: "table-row",
        cell: cn(
          "relative h-10 w-10 p-0 text-center align-middle text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-r-md",
          props.mode === "range"
            ? "[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md"
            : "[&:has([aria-selected])]:rounded-md"
        ),
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-medium text-[#2D2D2D] aria-selected:opacity-100 hover:bg-[#EEEBD0]/80"
        ),
        day_range_start: "day-range-start",
        day_range_end: "day-range-end",
        day_selected:
          "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-[#EEEBD0] text-[#2D2D2D] font-semibold",
        day_outside:
          "day-outside text-[#2D2D2D]/35 aria-selected:bg-accent/50 aria-selected:text-[#2D2D2D]/70",
        day_disabled: "text-[#2D2D2D]/25 opacity-60",
        day_range_middle:
          "aria-selected:bg-[#9ED3AB]/50 aria-selected:text-[#2D2D2D]",
        day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <ChevronLeft className={cn("h-4 w-4", className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <ChevronRight className={cn("h-4 w-4", className)} {...props} />
        ),
      }}
      {...props} />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
